module.exports = __webpack_public_path__ + "img/img_4.bcd82bfc.png";